import {ReactNode} from 'react';

import styles from '@/components/css/FixedTopRight.module.css';

export default function FixedTopRight({children}: {children: ReactNode}) {
  return <div className={styles.fixedTopRight}>{children}</div>;
}
